/**
 * Dependencies
 */
import { cloneDeep } from 'lodash'

/**
 * New Comp Set
 *
 * @type {Object}
 */
const state = {
    selected: null,
    options: [
        {
            key: 'rent_comps',
            title: 'Rent Comps'
        },
        {
            key: 'sales_comps',
            title: 'Sales Comps'
        }
    ],
    data: null,
    loading: false,
    error: false
}

/**
 * Return a fresh copy of the base state
 *
 * @return {Object}
 */
export const getState = () => cloneDeep(state)

export default getState()



// WEBPACK FOOTER //
// ./src/state/modules/dom/new-compset/state.js